export default __webpack_public_path__ + "static/media/serviceBg0.190c8c59.jpg";